export default __webpack_public_path__ + "static/b-card-definition-and-anatomy-61c56d7a51dbf38186e359ab56c85022.jpg";